import React from 'react';
import { ApplicationPage } from '../../components/applications/ApplicationPage';
import { leadershipPage } from '../../data/applicationPages';
export function LeadershipPage() {
  return <ApplicationPage content={leadershipPage} demoDomainId="leadership" data-id="element-1818" data-mp="1lbg7ahidvta6" />;
}